<template>
  <div class="cropsManagement-page">
    <div class="all-content-container">
      <div class="table-content-container">
        <div class="table-title-container">
          <div class="title_boder">
            <div class="title-back">
              <h4>农事装备</h4>
              <p class="backBth" style="margin-top: 9px" @click="backBthCurrent()">
                <i class="el-icon-caret-left"></i>
                <span>返回</span>
              </p>
            </div>
            <el-button v-allow="'010102'" type="primary" class="adduser" @click="add()">添加</el-button>
          </div>
        </div>
        <div class="table-content" style="margin-top: 15px; border: none">
          <div class="table-table">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#f4f5f7' }">
              <!-- <el-table-column prop="workCode" label="农事装备编码" align="center"></el-table-column> -->
              <el-table-column prop="orderNum" label="排序号" align="center"></el-table-column>
              <el-table-column prop="name" label="农事装备" align="center"></el-table-column>
              <el-table-column align="center" label="装备图片">
                <template slot-scope="scope">
                  <el-image v-if="scope.row.image" style="height: 50px" :src="scope.row.image != null ? scope.row.image.split(',')[0] : ''" :preview-src-list="scope.row.image != null ? scope.row.image.split(',') : []" fit="contain"> </el-image>
                  <p v-else>无</p>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button v-allow="'010103'" type="text" @click="edit(scope.row.id)">编辑</el-button>
                  <el-button v-allow="'010104'" type="text" @click="del(scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-content-container" style="padding-top: 20px">
            <el-pagination background layout="prev, pager, next,jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" :total="total"></el-pagination>
          </div>
        </div>
        <div class="pagination-container">
          <el-dialog :title="dialogTitle" :visible.sync="centerDialogVisible" width="650px" center style="z-index: 10000" :before-close="resetForm">
            <div class="info-content-container info-content-container-add">
              <el-form :inline="true" :model="dialogform" style="margin-left: 100px" :rules="dialogformRules" ref="dialogform">
                <!-- <el-form-item label="分组：" label-width="90px">
                  <el-cascader expand-trigger="hover" v-model="groupIdArr_" :options="groupArray" :props="optionProps" @change="groupChange_" placeholder="请选择分组" collapse-tags clearable></el-cascader>
                </el-form-item> -->
                <el-form-item label="排序号：" label-width="120px" prop="orderNum">
                  <el-input v-model="dialogform.orderNum" placeholder="请输入排序号" style="width: 344px" maxlength="20" clearable></el-input>
                </el-form-item>
                <el-form-item label="农事装备：" label-width="120px" prop="name">
                  <el-input v-model="dialogform.name" placeholder="请输入农事装备" style="width: 344px" maxlength="20" clearable></el-input>
                </el-form-item>
                <el-form-item label="装备图片：" label-width="120px" prop="image">
                  <UploadImg para="image" @setImg="setImg" :imgUrl="dialogform.image" width="150" height="100"></UploadImg>
                </el-form-item>
              </el-form>
            </div>
            <span slot="footer" class="dialog-footer1">
              <el-button @click="resetForm">取 消</el-button>
              <el-button type="primary" @click="submitForm('dialogform')">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UploadImg from '@/components/upload/UploadImg.vue'

export default {
  components: { UploadImg },
  name: 'cropsManagement',
  data() {
    return {
      selectedCateKeys: [],
      zhongzhidap: '',
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        multiple: false
      },
      optionProps2: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: false,
        multiple: true
      },
      multiple: true,
      options: [],
      dialogformName: '',
      dialogformModelStageId: [],
      show: false,
      headers: {
        // 身份验证
        AUTHORIZATION: sessionStorage.getItem('TOKEN')
      },
      dialogTitle: '', //弹框title :headers="headers"
      input: '',
      name: '', //农事装备
      groupName: '', //大棚name
      centerDialogVisible: false,
      currentPage: 1,
      total: 0,
      pagesize: 8,

      dialogformRules: {
        // image: [{ required: true, message: '请上传农事装备图片', trigger: 'change' }],
        name: [{ required: true, message: '请输入农事装备', trigger: 'blur' }],
        orderNum: [{ required: true, message: '请输入排序号', trigger: 'blur' }],
        workCode: [{ required: true, message: '请输入农事装备编码', trigger: 'blur' }],
        image: [{ required: true, message: '请上传图片', trigger: 'change' }]
      },

      id: '',
      tableData: [],
      srcList: [],
      isEdit: 0,
      groupIdArr_: [],
      groupArray: [],
      greenhouseId: '',
      dialogform: {
        id: '',
        name: '',
        groupId: '',
        workCode: '',
        selectedCateKeys: [],
        orderNum: '',
        image: '',
        groupIdArr_: ''
      }
    }
  },
  created() {
    this.init()
    // this.add()
    console.log(this.dialogform, 223)
  },
  methods: {
    // 上传图片
    setImg(url) {
      this.dialogform.image = url
      this.$forceUpdate()
    },
    resetForm() {
      this.centerDialogVisible = false
      this.groupIdArr_ = []

      this.$refs['dialogform'].resetFields()
    },
    // 保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 保存农事装备
          this.saveGrowthCrop()
        }
      })
    },
    // 大棚选择
    chang_val(val) {
      // 不是三级分类
      if (this.selectedCateKeys.length !== 2) {
        this.selectedCateKeys = []
        return
      }
      this.greenhouseId = val[val.length - 1][val[val.length - 1].length - 1]
    },
    // 数据请求
    init() {
      this.getGrowthCropList()
      this.getAllGrowthCrops()
    },
    //分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.getGrowthCropList() //列表数据
    },
    //  查询
    queryOnSubmit() {
      this.id = ''
      this.getGrowthCropList()
    },
    //重置
    relruonSubmit() {
      this.name = ''
      this.selectedCateKeys = []
      this.getGrowthCropList()
    },
    //新增
    add() {
      this.emUpty()
      this.centerDialogVisible = true
      this.dialogTitle = '添加农事装备'
      this.id = ''
      this.dialogform.id = ''
      this.emUpty()
      this.show = false
    },
    //弹框取消按钮
    cancellation() {
      this.centerDialogVisible = false
      this.emUpty()
    },
    emUpty() {
      this.dialogform.groupIdArr_ = ''
      this.dialogform.name = ''
      this.dialogform.image = ''
      this.dialogform.orderNum = ''
    },
    //编辑
    edit(id) {
      this.isEdit = 1
      this.id = id
      this.emUpty()
      this.centerDialogVisible = true
      this.dialogform.id = id
      this.dialogTitle = '编辑农事装备'
      this.getGrowthCrop(id)
    },
    // 查询农事装备列表
    getGrowthCropList() {
      this.$api.growthModel
        .getProductionDeviceList({
          pageNum: this.currentPage, //第几页，默认1
          pageSize: this.pagesize, //默认展示多少条，默认10
          // this.groupId, //大棚name
          // this.id, //
          // this.image, //图片
          name: this.name //名称
        })
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data
            if (this.tableData.length == 0 && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1
              this.getGrowthCropList()
            }
            this.total = res.count
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    // 删除
    del(id) {
      this.$confirm('是否删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(res => {
          this.$api.system.delfun(`/pc/productionDevice/delProductionDevice`, id).then(res => {
            // this.getUserMessageList();
            this.getGrowthCropList()
            this.$message({
              type: 'success',
              message: res.msg
            })
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 保存农事装备
    saveGrowthCrop() {
      let groupId = ''
      // if (this.dialogform.groupId) {
      //   this.dialogform.groupId.forEach((val) => {
      //     if (val.length == 2) {
      //       if (groupId.length > 0) {
      //         groupId += ','
      //       }
      //       groupId += val[1]
      //     }
      //   })
      // }

      this.$api.growthModel
        .saveProductionDevice(this.dialogform)
        .then(res => {
          if (res.code == 200) {
            this.centerDialogVisible = false
            this.getGrowthCropList()
            this.isEdit = 0
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.emUpty()
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    //查询农事装备详情getGrowthCrop
    getGrowthCrop(id) {
      this.$api.growthModel
        .getProductionDevice({ id: id })
        .then(res => {
          if (res.code == 200) {
            // this.groupIdArr_ = [this.getParentGroupId(res.data.groupId), res.data.groupId]

            this.dialogform = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    groupChange_() {
      if (!this.groupIdArr_ || this.groupIdArr_.length != 2) {
        this.groupIdArr_ = []
        this.dialogform.groupId = ''
      } else {
        this.dialogform.groupId = this.groupIdArr_[1]
      }
    },
    // 获取上级分组id
    getParentGroupId(groupId) {
      let parentGroupId = 0
      this.groupArray.every(function (val) {
        if (val.children) {
          let isEnd = false
          val.children.every(function (val2) {
            if (val2.id == groupId) {
              parentGroupId = val2.parentId
              isEnd = true
            }

            return val2.id != groupId
          })

          return !isEnd
        }
      })

      return parentGroupId
    },
    // 查询全部
    getAllGrowthCrops() {
      this.$api.system
        .getGroupList()
        .then(res => {
          if (res.code == 200) {
            this.groupArray = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多上传10张图片`)
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.srcList = []
        this.show = true
        this.$forceUpdate()
        this.dialogform.image = res.data
        this.$toaster.ok(res.msg)

        this.imgUpdateProgress = 100
        setTimeout(() => {
          this.isUpdateSuccess = false
          this.imgUpdateProgress = 0
        }, 200)
      }
    },
    handleAvatarProgress(event, file, fileList) {
      // 文件上传时的进度
      this.isUpdateSuccess = true
      var timer = setInterval(() => {
        this.imgUpdateProgress += 10
        if (this.imgUpdateProgress >= 90) {
          clearInterval(timer)
        }
      }, 200)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isSize = file.size / 1024 / 1024 < 5

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 、PNG 格式!')
      }
      if (!isSize) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isJPG && isSize
    },
    backBthCurrent() {
      this.$router.go(-1)
    }
  },
  computed: {
    // 当前选中id的最后一个
    groupId() {
      if (this.selectedCateKeys.length === 2) {
        return this.selectedCateKeys[1]
      }
      return null
    },
    // 当前选中id的最后一个
    groupId1() {
      if (this.dialogform.selectedCateKeys.length === 2) {
        return this.dialogform.selectedCateKeys[1]
      }
      return null
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/style/cropsManagement.scss';

li {
  padding-left: 10px;
}
.el-button--primary[data-v-f816515a] {
  margin-right: 5px;
}
.adduser {
  margin-top: 7px;
  margin-right: 11px;
}
</style>
